/* Cart drawer — frase "Você está economizando" (atualiza no cartUpdate) */
(function () {
  'use strict';

  function getRoot() {
    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root.replace(/\/$/, '');
      }
    } catch (e) {}
    return '';
  }

  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + v;
  }

  async function updateSavings() {
    var boxes = document.querySelectorAll('[data-cart-savings]');
    if (!boxes.length) return;
    try {
      var res = await fetch(getRoot() + '/cart.js');
      if (!res.ok) return;
      var cart = await res.json();
      var savings = 0;
      cart.items.forEach(function (item) {
        if (item.compare_at_price && item.compare_at_price > item.price) {
          savings += (item.compare_at_price - item.price) * item.quantity;
        }
      });
      boxes.forEach(function (box) {
        var val = box.querySelector('[data-cart-savings-value]');
        if (val) val.textContent = formatMoney(savings);
        box.classList.toggle('m:hidden', savings <= 0);
      });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateSavings);
  } else {
    updateSavings();
  }
  document.addEventListener('shopify:section:load', updateSavings);
  if (window.MinimogEvents && window.MinimogTheme) {
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, function () {
      setTimeout(updateSavings, 300);
    });
  }
})();
